import { render } from "./dashboard-user.vue?vue&type=template&id=1aba7eaf&scoped=true"
import script from "./dashboard-user.vue?vue&type=script&lang=js"
export * from "./dashboard-user.vue?vue&type=script&lang=js"

import "./dashboard-user.vue?vue&type=style&index=0&id=1aba7eaf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aba7eaf"]])

export default __exports__